import { createSlice } from "@reduxjs/toolkit";
import { PSP_FROM_DATE, PSP_TO_DATE } from "../../../Utils/FilterDateKeys";
import dateFormat from "dateformat";
import { ServiceProviderFieldsJSON } from "../../../pages/PSP/ServiceProvider/Json/ServiceProviderFieldsJson";
const enterpriseid = localStorage.getItem("enterpriseid");

const initialState = {
  serviceProviderData: [],
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  pspSwitch: {
    id: null,
  },
  pspFieldJson: ServiceProviderFieldsJSON,
  pspCategoryDropdown: [],
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [PSP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [PSP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const serviceProviderSlice = createSlice({
  name: "serviceProvider",
  initialState,
  reducers: {
    setServiceProviderData(state, action) {
      state.serviceProviderData = action.payload;
    },
    setPspFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    // setOrderFilterForm: (state, action) => {
    //   state.filter.form = action.payload;
    // },
    setPspFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // enterpriseid: enterpriseid,
            // [PSP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [PSP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[PSP_FROM_DATE];
          delete state.filter.form[PSP_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setPspFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setPspSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setPspSwitch(state, action) {
      state.pspSwitch.id = action.payload;
    },
    setPspFieldJson(state, action) {
      state.pspFieldJson = action.payload;
    },
    setPspCategoryDropdown(state, action) {
      state.pspCategoryDropdown = action.payload;
    },
  },
});

export const {
  setServiceProviderData,
  setPspFilterApi,
  setPspFilterForm,
  setPspFilterFormCopy,
  setPspSorting,
  setPspSwitch,
  setPspFieldJson,
  setPspCategoryDropdown,
} = serviceProviderSlice.actions;

export default serviceProviderSlice.reducer;
